import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import ProfileCard from '@shared/shared-card/ProfileCard';
import Share from '@shared/Share';
import useStorage from '@utils/hooks/useStorage';
import { getImgUrl } from '@utils/functions/getImgUrl';

const BlogDetails = ({ blogData, deviceType, relatedBlogs }) => {
  const { getItem } = useStorage();
  const currentUtm = getItem('utm') && JSON.parse(getItem('utm'));
  // set query string for redirect
  let queryString = '';
  for (const property in currentUtm) {
    queryString += `&${property}=${currentUtm[property]}`;
  }
  return (
    <>
      <div className="mx-4 mt-4 lg:ml-0">
        <div>
          <h1 className="mt-8 mb-4 lg:w-[85%]">{blogData?.title}</h1>
          {blogData?.category?.data?.attributes.name && (
            <span className="whitespace-nowrap rounded bg-[#CC0000] py-1 px-2.5 text-center align-baseline font-satoshi-medium text-sm font-medium  leading-none text-white">
              {blogData?.category?.data?.attributes.name}
            </span>
          )}
          <div className="my-8 text-base lg:w-[85%]">{blogData.description}</div>
          <img
            src={blogData?.image?.data?.attributes?.url}
            alt={blogData.title}
            className="mb-8 w-full pr-2 lg:h-[25rem] lg:w-[85%] lg:pr-0"
          />
          <ReactMarkdown
            components={{
              h1: (props) => <h1 {...props} className="mb-4 text-4xl" />,
              h2: (props) => <h2 {...props} className="mb-4 text-3xl" />,
              h3: (props) => <h3 {...props} className="mb-4 text-2xl" />,
              h4: (props) => <h4 {...props} className="mb-4 text-xl" />,
              h4: (props) => <h5 {...props} className="mb-4 text-xl" />,
              code: (props) => (
                <>
                  <iframe
                    className="mb-8 h-[450px] w-full md:w-[85%]"
                    src={props.children[0]}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </>
              ),
              p: (props) => <p {...props} className="mb-8 text-justify text-base lg:w-[85%]" />,
              a: ({ node, href, children, ...props }) => (
                <a {...props} href={href} target="_blank">
                  <a className="text-base text-blue hover:underline">{children}</a>
                </a>
              ),
              ul: ({ node, ...props }) => <ul {...props} className="mb-4 list-inside list-disc" />,
              strong: ({ node, ...props }) => (
                <span {...props} className="text-base font-extrabold" />
              ),
              li: ({ node, ...props }) => <li {...props} className="listing text-base" />,
              ol: ({ node, ...props }) => (
                <ol
                  {...props}
                  className="mb-4 list-inside list-decimal font-satoshi-bold font-bold "
                />
              ),
            }}
            // remarkToRehypeOptions={{ allowDangerousHtml: true }}
            // remarkPlugins={[remarkGfm]}
          >
            {blogData.content}
          </ReactMarkdown>
          <div className="block lg:hidden">
            <Share slug={`/blogs/${blogData.slug}`} />
          </div>
          {blogData?.author.data && (
            <ProfileCard
              image={blogData?.author?.data?.attributes?.picture}
              name={blogData?.author?.data?.attributes?.name}
              designation={blogData?.author?.data?.attributes?.Designation}
              linkedinUrl={blogData?.author?.data?.attributes?.linkedinUrl}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
